import { render, staticRenderFns } from "./MenuGeneratorLink.vue?vue&type=template&id=3fb3afb6"
import script from "./MenuGeneratorLink.vue?vue&type=script&lang=js"
export * from "./MenuGeneratorLink.vue?vue&type=script&lang=js"
import style0 from "./MenuGeneratorLink.vue?vue&type=style&index=0&id=3fb3afb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports